import { Fragment } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import FeatureGates from "@atlassian/feature-gate-js-client";

import { AisSitesType } from "@/libraries/bxp-web-stargate-client/src/index";

import { LeftLines } from "../../graphics/variant-cfind-1109/left-lines";
import { RightLines } from "../../graphics/variant-cfind-1109/right-lines";
import { Team24AdBannerConfluence } from "../cfind-1357-team-24-ad-banner";

import LogMeInSection from "./log-me-in";
import VideoSection from "./video";

const leftLines = css({
    position: "absolute",
    insetBlockStart: 0,

    [media.below.md]: {
        display: "none"
    }
});

const rightLines = css({
    position: "absolute",
    insetBlockStart: 300,
    insetInlineEnd: 0,

    [media.below.md]: {
        display: "none"
    }
});

const relative = css({
    position: "relative"
});

interface HeroSectionProps {
    confluenceSites: AisSitesType[];
    userProfileName: string | undefined;
    loading: boolean;
}

export const HeroSection = ({ ...props }: HeroSectionProps) => {
    const showConfluenceTeam24AdBanner = FeatureGates.getExperimentValue(
        "cfind-1357-confluence-team-24-ad-banner",
        "enrolled",
        false
    );
    return (
        <Fragment>
            <div css={relative}>
                <div css={leftLines}>
                    <LeftLines />
                </div>
                <div css={rightLines}>
                    <RightLines />
                </div>
                <div css={relative}>
                    <LogMeInSection {...props} />
                </div>
            </div>
            {showConfluenceTeam24AdBanner ? (
                <Team24AdBannerConfluence />
            ) : (
                <VideoSection />
            )}
        </Fragment>
    );
};

export default HeroSection;
